import { mapMutations, mapGetters, mapActions } from "vuex";
import it from "vue2-datepicker/locale/es/it";

export default {
    name: "choice-branches",
    computed: {
        ...mapGetters({
            popupStatus: "branches/openBranchesPopup",
            branchesList: "branches/branchesList",
            currentBranch: "branches/currentBranch",
            basket: "basket/basket",
            robots: "system/robots",
            branches: "branches/branchesList",
        }),
    },
    watch: {
        branches() {
            this.closePopUp();
        },
    },
    methods: {
        ...mapMutations({
            changePopupStatus: "branches/OPEN_POPUP_BRANCHES",
            setCurrentBranch: "branches/SET_CURRENT_BRANCH",
            resetBasket: "basket/RESET_BASKET",
        }),
        ...mapActions({
            getBranches: "branches/GET_BRANCHES",
        }),
        setBranchId(item) {
            if (item.id !== this.currentBranch.id) {
                localStorage.getItem("products")
                    ? localStorage.setItem(`basket_${this.currentBranch.id}`, localStorage.getItem("products"))
                    : "";
                localStorage.getItem(`basket_${item.id}`)
                    ? localStorage.setItem("products", localStorage.getItem(`basket_${item.id}`))
                    : this.resetBasket();
            }
            this.setCurrentBranch(item);
            localStorage.setItem("branchId", JSON.stringify(item));
            localStorage.setItem("Global-version", 0);

            this.closePopUp();
            location.reload();
        },
        closePopUp() {
            if (localStorage.getItem("branchId") === null) {
                this.changePopupStatus(false);
            } else {
                this.changePopupStatus(true);
            }
        },
        forceClosePopup() {
            this.changePopupStatus(true);
            this.setCurrentBranch(this.branchesList.find(item => item.slug === "kremencuk"));
        },
    },
    created() {
        if (!localStorage.getItem("branchId")) {
            localStorage.setItem("Global-version", 1);
        }
    },
};
